import { map as _map } from 'lodash-es';
import { Fragment, useMemo } from 'react';
import { useFormikContext } from 'formik';
import Typography from '@mui/material/Typography';
import RadioGroupField from '../forms/radio-group-field';
import TextAreaField from '../forms/text-area-field';
import { eventRegistrationTypes } from '../../utils/events';
import type { EventFormValues } from './form';

type Props = {
  disabled: boolean;
  forceTouched: boolean;
};

const EventFormRegistration = ({ disabled, forceTouched }: Props) => {
  const {
    values: { registrationType },
  } = useFormikContext<EventFormValues>();

  const options = useMemo(() => {
    return _map(eventRegistrationTypes, ({ name, description }, value) => ({
      label: `${name}${description ? ` (${description})` : ''}`,
      value,
    }));
  }, []);

  return (
    <Fragment>
      <Typography variant="h2">Registration</Typography>
      <RadioGroupField
        name="registrationType"
        label="Registration"
        disabled={disabled}
        touched={forceTouched}
        options={options}
      />
      {registrationType === 'APPROVAL_REQUIRED' && (
        <Fragment>
          <Typography variant="body2" sx={{ mt: 1, mb: 1 }}>
            Approved attendees see location, route, and any private details below.
          </Typography>
          <TextAreaField
            name="approvalPrompt"
            label="Instructions for requesters"
            helperText="e.g., Tell us your pace and experience level"
            disabled={disabled}
            touched={forceTouched}
          />
          <TextAreaField
            name="approvalDescription"
            label="Private details for approved attendees"
            disabled={disabled}
            touched={forceTouched}
            helperText="Only shown after approval. e.g., exact meeting spot, Strava link, group rules. Markdown supported."
          />
        </Fragment>
      )}
    </Fragment>
  );
};

export default EventFormRegistration;
